export default function moveClassesToBody(selector, ignore = []) {
  const elements = document.querySelectorAll(selector);

  document.body.className = [].slice.call(elements)

    // Build an array of classes attached to the element
    .map(getClassListAsArray)

    // Reduce the multidimensional array into a single array
    .reduce((all, current) => all.concat(current), getClassListAsArray(document.body))

    // Filter out all of the ignored values
    .filter((value) => ignore.indexOf(value) === -1)

    // Join values by a space
    .join(' ');
}

function getClassListAsArray(element) {
  return element.className

    // Remove leading and trailing spaces
    .trim()

    // Remove unnessesary spaces
    .replace(/\s{2,}/, ' ')

    // Split the classes into strings
    .split(' ')

    // Trim the remaining entries
    .map((className) => className.trim());
}
